import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const EditProfileMediaResumeItemContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BLUE_GRAY : COLORS.COOL_TONED_GRAY,
  borderRadius: 8,
  padding: 10,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
